export function setProductRequest(product) {
  var commercialization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var flow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: 'SET_PRODUCT_REQUEST',
    params: {
      product: product,
      commercialization: commercialization,
      flow: flow
    }
  };
}